import { useState } from "react";
import { useNavigate } from "react-router-dom";

const roles = ["認購流程", "利潤說明"];

const steps = [
  {
    number: 1,
    title: "選擇貨源認購",
    description: "瀏覽體驗區或 VIP 區商品，選擇心儀貨源並查看認購價與銷售價。",
    icon: "ri-shopping-cart-line",
    image: "https://static.readdy.ai/image/823a8f074b021e82ba2884013917a5c5/4dd46c7f116a8fb377065ef226863e77.png",
  },
  {
    number: 2,
    title: "達標即出貨",
    description: "認購達標後立即安排出貨，未達標則全額退款，零風險參與。",
    icon: "ri-truck-line",
    image: "https://static.readdy.ai/image/823a8f074b021e82ba2884013917a5c5/67c9a4d73a4a272f3b73381fee56859e.png",
  },
  {
    number: 3,
    title: "轉售賺取差價",
    description: "收到貨品後透過平台轉售或自行銷售，賺取認購價與市價之間的利潤差。",
    icon: "ri-coins-line",
    image: "https://static.readdy.ai/image/823a8f074b021e82ba2884013917a5c5/e97cf363eb98be43d08dba149bbae710.png",
  },
];

const profitSteps = [
  {
    number: 1,
    title: "低價認購",
    description: "平台以集量採購取得低於市價 30%-50% 的進貨價，會員以認購價參與。",
    icon: "ri-arrow-down-line",
    image: "https://static.readdy.ai/image/823a8f074b021e82ba2884013917a5c5/e4ba0d423d058d6a364e53272816d964.png",
  },
  {
    number: 2,
    title: "市場價轉售",
    description: "認購商品均為熱門流通品項，轉售價格貼近市場均價，利潤空間穩定。",
    icon: "ri-store-line",
    image: "https://static.readdy.ai/image/823a8f074b021e82ba2884013917a5c5/6bf337873c8ea33bc6349b2fb818e9a0.png",
  },
  {
    number: 3,
    title: "利潤入帳",
    description: "轉售完成後利潤即時入帳，可提領或再投入下一輪認購，資金高效流轉。",
    icon: "ri-wallet-3-line",
    image: "https://static.readdy.ai/image/823a8f074b021e82ba2884013917a5c5/5f9a2cd1d2f153bef520f659a08938e4.png",
  },
];

export default function HowItWorksSection() {
  const [activeRole, setActiveRole] = useState("認購流程");
  const navigate = useNavigate();

  return (
    <section id="how-it-works" className="w-full bg-stone-50 py-12 md:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <h2 className="font-display text-xl md:text-2xl font-bold text-stone-800 text-center tracking-wide uppercase">
          如何運作
        </h2>
        <p className="font-body text-sm text-stone-500 text-center mt-2 max-w-md mx-auto">
          三步驟完成認購到獲利，流程透明、風險可控
        </p>

        <div className="flex items-center justify-center gap-1 mt-6">
          {roles.map((role) => (
            <button
              key={role}
              onClick={() => setActiveRole(role)}
              className={`font-body text-xs md:text-sm font-medium px-4 md:px-8 py-2 transition-colors whitespace-nowrap cursor-pointer ${
                activeRole === role
                  ? "text-stone-800 border-b-2 border-stone-800"
                  : "text-stone-400 hover:text-stone-600"
              }`}
            >
              {role}
            </button>
          ))}
          <button
            onClick={() => navigate("/subscription-mode")}
            className="font-body text-xs md:text-sm font-medium px-4 md:px-8 py-2 transition-colors whitespace-nowrap cursor-pointer text-stone-400 hover:text-stone-800 border-b-2 border-transparent hover:border-stone-300"
          >
            認購模式
          </button>
        </div>

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {activeRole === "認購流程" &&
            steps.map((step) => (
              <div key={`process-${step.number}`} className="text-center">
                <div className="relative mx-auto w-full max-w-[240px] aspect-[4/3]">
                  <div className="w-full h-full rounded-xl overflow-hidden bg-stone-100 border border-stone-200 flex items-center justify-center">
                    {step.image ? (
                      <img src={step.image} alt={step.title} className="w-full h-full object-cover" />
                    ) : (
                      <div className="w-14 h-14 rounded-xl bg-stone-200 flex items-center justify-center">
                        <i className={`${step.icon} text-stone-500 text-2xl`} />
                      </div>
                    )}
                  </div>
                  <span className="absolute -top-3 -right-3 z-10 font-body text-xs font-bold text-white bg-rose-800 rounded-full w-8 h-8 flex items-center justify-center">
                    {step.number}
                  </span>
                </div>
                <h3 className="font-body text-sm font-bold text-stone-800 uppercase tracking-wider mt-5">
                  {step.title}
                </h3>
                <p className="font-body text-xs text-stone-500 mt-2 leading-relaxed max-w-xs mx-auto">
                  {step.description}
                </p>
              </div>
            ))}

          {activeRole === "利潤說明" &&
            profitSteps.map((step) => (
              <div key={`profit-${step.number}`} className="text-center">
                <div className="relative mx-auto w-full max-w-[240px] aspect-[4/3]">
                  <div className="w-full h-full rounded-xl overflow-hidden bg-stone-100 border border-stone-200 flex items-center justify-center">
                    {step.image ? (
                      <img src={step.image} alt={step.title} className="w-full h-full object-cover" />
                    ) : (
                      <div className="w-14 h-14 rounded-xl bg-stone-200 flex items-center justify-center">
                        <i className={`${step.icon} text-stone-500 text-2xl`} />
                      </div>
                    )}
                  </div>
                  <span className="absolute -top-3 -right-3 z-10 font-body text-xs font-bold text-white bg-rose-800 rounded-full w-8 h-8 flex items-center justify-center">
                    {step.number}
                  </span>
                </div>
                <h3 className="font-body text-sm font-bold text-stone-800 uppercase tracking-wider mt-5">
                  {step.title}
                </h3>
                <p className="font-body text-xs text-stone-500 mt-2 leading-relaxed max-w-xs mx-auto">
                  {step.description}
                </p>
              </div>
            ))}
        </div>
      </div>
    </section>
  );
}